import axios from 'axios'

export const adminActivityService = ({
  getAllAdminUsers (token) {
    return axios.get('/api/User/GetAdminUsers', {headers: {'Authorization': 'Bearer ' + token}})
  },
  listActivityByDate (token, userId, startDate, endDate) {
    var requestObj = {
      UserId: userId,
      StartTS: startDate,
      EndTS: endDate
    }
    return axios.post('/api/AdminActivity/ListActivityByDate', requestObj, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/server-util/admin-activity-service.js